var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDifference(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 159.74 139.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#505050;}.cls-2{fill:#9ca5ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "136.42 68.21 136.42 105.61 98.57 67.77 136.42 68.21"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.05,
    width: 86.69,
    height: 86.69,
    rx: 10.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.37,28.26H94.42a3.52,3.52,0,1,1,0-7h44a3.52,3.52,0,0,1,0,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.4,27.71a3.51,3.51,0,0,1-3.52-3.52V19.47a3.52,3.52,0,1,1,7,0v4.72A3.52,3.52,0,0,1,116.4,27.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.9,70.74a3.52,3.52,0,0,1-2.09-6.36,128.21,128.21,0,0,0,24.85-23.79,113.28,113.28,0,0,0,11.13-17A3.52,3.52,0,0,1,138,26.94a121.39,121.39,0,0,1-11.81,18A135.53,135.53,0,0,1,100,70.06,3.52,3.52,0,0,1,97.9,70.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.35,70.74a3.51,3.51,0,0,1-2.1-.7,140.48,140.48,0,0,1-18.08-16A127,127,0,0,1,97.48,35.36a3.52,3.52,0,1,1,5.92-3.81,121,121,0,0,0,13.88,17.63A133.77,133.77,0,0,0,134.46,64.4a3.52,3.52,0,0,1-2.11,6.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.32 101.65 23.32 139.06 61.17 101.21 23.32 101.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 33.44,
    width: 86.69,
    height: 86.69,
    rx: 10.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,104.19a3.39,3.39,0,0,1-1.2-.22,3.52,3.52,0,0,1-2.11-4.51L40,51.72a3.52,3.52,0,0,1,6.62,2.4l-17.3,47.74A3.52,3.52,0,0,1,26,104.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.66,104.19a3.52,3.52,0,0,1-3.31-2.33L40.05,54.12a3.52,3.52,0,1,1,6.62-2.4L64,99.46A3.51,3.51,0,0,1,61.86,104,3.35,3.35,0,0,1,60.66,104.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.37,84.65h-18a3.52,3.52,0,1,1,0-7h18a3.52,3.52,0,1,1,0,7Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifference);
export default __webpack_public_path__ + "static/media/difference.768db62a7426802f1c6b3d214928611c.svg";
export { ForwardRef as ReactComponent };